import p from "./design-system.es85.js";
import d from "./design-system.es84.js";
import { resolveComponent as i, openBlock as f, createBlock as g, withCtx as t, createVNode as n, createTextVNode as _, toDisplayString as h } from "vue";
import k from "./design-system.es128.js";
const D = {
  name: "DsRouterPaginationFooter",
  components: {
    DsPaginationFooter: p,
    DsPagerButton: d
  },
  props: {
    /**
     * The total number of items.
     */
    total: {
      type: Number,
      required: !0
    },
    /**
     * The number of items per page.
     */
    pageSize: {
      type: Number,
      required: !0
    },
    /**
     * The current page. This cannot be used in conjunction with the `offset` prop.
     */
    page: {
      type: Number,
      default: null
    },
    /**
     * Maps the page number to a route path.
     */
    mapRoute: {
      type: Function,
      required: !0
    }
  }
};
function C(R, b, e, B, P, x) {
  const c = i("DsIconButton"), u = i("RouterLink"), l = i("DsPagerButton"), s = i("DsPaginationFooter");
  return f(), g(s, {
    "page-size": e.pageSize,
    page: e.page,
    total: e.total
  }, {
    previous: t(({ disabled: o }) => [
      n(u, {
        to: e.mapRoute(e.page - 1),
        custom: ""
      }, {
        default: t(({ href: a, navigate: r }) => [
          n(c, {
            as: "a",
            href: a,
            name: "chevron-left",
            disabled: o,
            onClick: r
          }, null, 8, ["href", "disabled", "onClick"])
        ]),
        _: 2
      }, 1032, ["to"])
    ]),
    page: t(({ page: o, current: a }) => [
      n(u, {
        to: e.mapRoute(o),
        custom: ""
      }, {
        default: t(({ href: r, navigate: m }) => [
          n(l, {
            as: "a",
            href: r,
            current: a,
            onClick: m
          }, {
            default: t(() => [
              _(h(o), 1)
            ]),
            _: 2
          }, 1032, ["href", "current", "onClick"])
        ]),
        _: 2
      }, 1032, ["to"])
    ]),
    next: t(({ disabled: o }) => [
      n(u, {
        to: e.mapRoute(e.page + 1),
        custom: ""
      }, {
        default: t(({ href: a, navigate: r }) => [
          n(c, {
            as: "a",
            href: a,
            name: "chevron-right",
            disabled: o,
            onClick: r
          }, null, 8, ["href", "disabled", "onClick"])
        ]),
        _: 2
      }, 1032, ["to"])
    ]),
    _: 1
  }, 8, ["page-size", "page", "total"]);
}
const z = /* @__PURE__ */ k(D, [["render", C]]);
export {
  z as default
};
//# sourceMappingURL=design-system.es92.js.map
